// Types
import { objectIdGenerationState } from './objectIdGenerationState';
/**
 * Get's a globally unique identifier string
 *
 * @return {string}
 */
export var getUniqueId = function () {
    objectIdGenerationState.uniqueIdCounter += 1;
    return "UID_" + objectIdGenerationState.uniqueIdCounter;
};
//# sourceMappingURL=getUniqueId.js.map